



















import ECharts from 'vue-echarts'
import AbpBase from "@/lib/abpbase"
import {Component} from "vue-property-decorator"
import {GetCompStatistics} from "@/api/report"
import patDlyRecord from '../../../components/patDlyRecord.vue'

@Component({
	components: {patDlyRecord, ECharts}
})
export default class AdjustPrice extends AbpBase {
	loading = false
	dates: any = []
	date: any = []
	data: any = []
	detailData: any = []
	isTemp = false
	detailShow = false
	patDlyRecordShow = false
	patData:any = {}
	echartsData: any = {
		tooltip: {
			trigger: 'item',
			formatter: "{a} <br/>{b}: {c} ({d}%)"
		},
		legend: {
			orient: 'vertical',
			x: 'left',
			data:[]
		},
		series: [
			{
				name:'占比',
				type:'pie',
				radius: ['50%', '70%'],
				avoidLabelOverlap: false,
				label: {
					normal: {
						show: false,
						position: 'center'
					},
					emphasis: {
						show: true,
						textStyle: {
							fontSize: '30',
							fontWeight: 'bold'
						}
					}
				},
				labelLine: {
					normal: {
						show: false
					}
				},
				data:[

				]
			}
		]
	}
	created() {
		const end = new Date();
		const start = new Date();
		end.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
		this.dates = [start, end]
		this.date = [start, end]
		this.init()
	}

	dateChange(e: any) {
		this.dates = e
		this.init()
	}

	options = {
		shortcuts: [
			{
				text: '一周',
				value() {
					const end = new Date();
					const start = new Date();
					end.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
					return [start, end];
				}
			},
			{
				text: '一个月',
				value() {
					const end = new Date();
					const start = new Date();
					end.setTime(start.getTime() - 3600 * 1000 * 24 * 29);
					return [start, end];
				}
			},
			{
				text: '三个月',
				value() {
					const end = new Date();
					const start = new Date();
					end.setTime(start.getTime() - 3600 * 1000 * 24 * 89);
					return [start, end];
				}
			}
		]
	}
	columns = [
		{
			title: '类别',
			key: 'type'
		},
		{
			title: '数量',
			key: 'count'
		},
		{
			title: '占比',
			key: 'ratio'
		},
		{
			title: '操作',
			width: 100,
			render: (h:any, p:any) => {
				return h('Button',{
					props:{type: 'primary'},
					on:{
						click:()=>{
							this.detail(p.row)
						}
					}
				},"详情")
			}
		}
	]
	detailColumns = [
		{
			title: '日期',
			key: 'date'
		},
		{
			title: '姓名',
			key: 'patientName'
		},
		{
			title: '操作',
			width: 100,
			render:(h:any, p:any) => {
				return h('Button',{
					props:{type: 'primary'},
					on:{
						click:()=>{
							this.jld(p.row)
						}
					}
				},"详情")
			}
		}
	]

	async init() {
		this.loading = true
		let res = await GetCompStatistics({
			IsTemp: this.isTemp,
			StartDate: this.dates[0],
			EndDate: this.dates[1]
		})
		// this.data = res.objects
		this.data = [
			{
				type: '123',
				count:5
			},{
				type: '321',
				count:5
			},
		]

		if (this.data.length) {
			let legendData:any = []
			let seriesData:any = []
			this.data.forEach((item:any)=>{
				legendData.push(item.type)
				seriesData.push({value:item.count, name:item.type})
			})
			this.echartsData.legend.data = legendData
			this.echartsData.series[0].data = seriesData
		} else {
			this.echartsData.legend.data = ['暂无数据']
			this.echartsData.series[0].data = [{value:null, name:null}]
		}

		this.loading = false
	}

	private detail(row: any) {
		this.detailData = row.items
		this.detailShow = true
	}
	jld(row: any){
		this.patData = {dialysisSignId: row.dialysisSignId, patientName: row.patientName}
		this.patDlyRecordShow = true
	}
	visibleChange(value:boolean){
		if(!value){
			this.detailShow = false
		}
	}
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/report/complication/index.vue